import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import router from './router'
import store from './store'
import GlobalComponents from '@/components/global'
import '@/assets/promise-6.1.0'
import {Loading, MessageBox, Message, Tooltip, Input, Radio, RadioGroup, Checkbox, CheckboxGroup, Select, Option, Form, FormItem, Button, InputNumber, Dialog} from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/element-custom.scss'
import pkg from '../package.json'

Vue.config.productionTip = false
Vue.use(GlobalComponents)
Vue.use(Loading.directive)
Vue.use(Tooltip)
Vue.use(Loading)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(InputNumber)
Vue.use(Dialog)
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.res = {
  name: pkg.name,
  version: pkg.version
}

console.log(`APP ${pkg.name} v${pkg.version} is running `)
